<template>
  <div v-if="positions.length" class="player-position-buttons w-100 d-flex justify-content-end mt-1" style="gap: 2px;">
    <button v-for="p in positions" :key="p.id"
            class="btn btn-xs py-0 px-2"
            :class="active === p.id ? 'btn-warning' : 'btn-outline-secondary'"
            style="font-size: 0.7rem;"
            @click.stop="$emit('toggle', p.id)">
      {{ p.id }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    // Lineup positions (e.g. GK) from the sport config
    positions: {
      type: Array,
      default: () => []
    },
    // Id of the position the player holds in the draft lineup
    active: {
      type: String,
      default: null
    }
  }
}
</script>
